module.exports = __webpack_public_path__ + "static/media/gralbelgrano.09890c21.webp";